import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

type Tone = 'neutral' | 'accent' | 'amber' | 'alert' | 'info';

const TONE: Record<Tone, string> = {
  neutral: 'border-line-bright text-ink-dim',
  accent: 'border-accent/40 bg-accent-dim text-accent',
  amber: 'border-amber/40 bg-amber-dim text-amber',
  alert: 'border-alert/40 bg-alert-dim text-alert',
  info: 'border-info/40 bg-info-dim text-info',
};

export function Badge({
  tone = 'neutral',
  children,
  className,
}: {
  tone?: Tone;
  children: ReactNode;
  className?: string;
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-sharp border px-1.5 py-px font-mono text-[10px] font-medium uppercase tracking-[0.1em]',
        TONE[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
